import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { STORAGE } from '../constants/local-storage.constants';
import { isPlatformBrowser } from '@angular/common';
import { UserModel } from '@coreModels';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  /**
   * This method is used to get token from localStorage
   * @returns token or null
   */
  public getToken(): string | null {
    return this.getItemStorage(STORAGE.TOKEN_KEY);
  }

  /**
   * This method is used to set token in localStorage
   * @param token
   */
  setToken(token: string): void {
    this.setItemStorage(STORAGE.TOKEN_KEY, token);
  }

  /**
   * This method is used to get user details from localStorage
   * @returns user
   */
  getUser(): any {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem(STORAGE.USER_KEY) || '{}') as UserModel;
    }
  }

  /**
   * This method is used to check whether user is logged in or not
   * @returns user is logged in or not
   */
  checkUserLoggedIn(): boolean {
    const token = this.getToken();
    return !!token;
  }

  /**
   * This method is used to set user in localStorage
   * @param user
   */
  setUser(user: any): void {
    this.setItemStorage(STORAGE.USER_KEY, JSON.stringify(user));
  }


  setCreditEarn(credit:any)
  {
    this.setItemStorage(STORAGE.CREDIT_EARN_KEY, JSON.stringify(credit));
  }

  getCreditEarn(): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(STORAGE.CREDIT_EARN_KEY);
    }
    return null; // Return null explicitly when running on the server
  }

  /**
   * This method is used to get data from localStorage by key
   * @param key
   * @returns value or null
   */
  getItemStorage(key: string): string | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(key);
    }
    return null;
  }

  /**
   * This method is used to set data in localStorage by key
   * @param key
   * @param data
   */
  setItemStorage(key: any, data: any) {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(key, data);
    }
  }

  /**
   * This method is used to remove data from localStorage by key
   * @param key
   */
  removeItemStorage(key: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(key);
    }
  }

  setSampleOrder(order: any) {
    localStorage.setItem(STORAGE.SAMPLE_ORDER_KEY, JSON.stringify(order));
  }

  getSampleOrder() {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(localStorage.getItem(STORAGE.SAMPLE_ORDER_KEY) || '[]');
    }
    return null;
  }



  /**
   * This method is used to clear localStorage
   */
  clearStorage(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.clear();
    }
  }

  setSearchFields(data: any, key: string = STORAGE.SEARCH_KEY) {
    this.setItemStorage(key, JSON.stringify(data));
  }

  getSearchFields(key: string) {
    if (isPlatformBrowser(this.platformId)) {
      return JSON.parse(this.getItemStorage(key) || '{}');
    }
    return null;
  }

}
